export default __webpack_public_path__ + "static/media/iic 10.09432016.JPG";